const constants = {
  SCENARIO_FETCH_START: 'SCENARIO_FETCH_START',
  SCENARIO_FETCH_END: 'SCENARIO_FETCH_END',
  SCENARIO_FETCH: 'SCENARIO_FETCH',
  SCENARIO_UPDATE: 'SCENARIO_UPDATE',
};

export default constants;
